// extracted by mini-css-extract-plugin
module.exports = {"GlobalFooter":"GlobalFooter_GlobalFooter__T0uJ6"};